import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const customTypeUtilities = [
  'text-micro',
  'text-caption',
  'text-body-xs',
  'text-body-sm',
  'text-body',
  'text-subheading',
  'text-heading-sm',
  'text-heading',
  'text-heading-lg',
  'text-display',
  'text-hero',
]

// tailwind-merge otherwise mistakes custom type utilities for text colours and drops the size.
const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': customTypeUtilities } },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
